import pkg from '../package.json';

import type { AppTimeouts } from './Def';

export const SDK_NAME = 'bluebell';
export const SDK_VERSION: string = pkg.version;

// global factory
export const __BLUEBELL_ROUTER__ = '__BLUEBELL_ROUTER__';
export const __BLUEBELL_ATOMIC__ = '__BLUEBELL_ATOMIC__';
export const __BLUEBELL_RESOURCE_MANAGER__ = '__BLUEBELL_RESOURCE_MANAGER__';
export const __BLUEBELL_UMD_EXPORT_RESOLVER__ = '__BLUEBELL_UMD_EXPORT_RESOLVER__';
export const __BLUEBELL_DOWNLOADER__ = '__BLUEBELL_DOWNLOADER__';
export const __BLUEBELL_DEV_TOOL__ = '__BLUEBELL_DEV_TOOL__';

// global map
export const __BLUEBELL_GLOBAL_MAP_UMD_EXPORTED__ = '__BLUEBELL_GLOBAL_MAP_UMD_EXPORTED__';
export const __BLUEBELL_GLOBAL_MAP_DOM_CONTAINER__ = '__BLUEBELL_GLOBAL_MAP_DOM_CONTAINER__';
export const __BLUEBELL_GLOBAL_MAP_DOWNLOADER__ = '__BLUEBELL_GLOBAL_MAP_DOWNLOADER__';

export const BLUEBELL_ROUTER_VERSION = 0x101;
export const BLUEBELL_RESOURCE_MANAGER_VERSION = 0x201;
export const BLUEBELL_UMD_EXPORT_RESOLVER_VERSION = 0x301;
export const BLUEBELL_DEV_TOOL_VERSION = 0x401;
export const BLUEBELL_DOWNLOADER_VERSION = 0x501;
export const BLUEBELL_ATOMIC_VERSION = 0x601;

export const DEFAULE_TIMEOUTS: AppTimeouts = {
    load: 5000,
    bootstrap: 4000,
    mount: 3000,
    unmount: 3000,
    update: 3000,
};

export const UNDER_TEST: boolean = navigator.userAgent.includes('jsdom/');
